import { Component } from '@angular/core';

@Component({
    selector: 'lib-placeholder',
    templateUrl: './placeholder.component.html',
    styleUrls: ['./placeholder.component.scss'],
    standalone: true
})
export class PlaceholderComponent {}
